import { Grid, Stack } from '@mui/material'
import logo from "../assets/logo.png"
import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { NavLink } from 'react-router';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

function SideBar() {
    return (
        <Stack alignItems={"end"} sx={{ backgroundColor: "#fff" }}>
            <Box sx={{ padding: 2, mt: 2 }}>
                <img src={logo} alt="" width={"40px"} />
            </Box>
            <Stack sx={{ gap: 2, width: "100%" }}>
                <NavLink to="/" className={({ isActive }) => {
                    return ` nav ${(isActive) && 'activeNav'}   `
                }}>
                    طلبات الدعم
                    <HomeOutlinedIcon />
                </NavLink>
                <NavLink to="/elementlist" className={({ isActive }) => {
                    return ` nav ${(isActive) && 'activeNav'}   `
                }}>

                    عنصر قائمة
                    <FeaturedPlayListIcon />
                </NavLink>
            </Stack>
        </Stack>
    )
}

export default SideBar